var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2,
    stroke: "#282C87",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2,
    stroke: "#282C87",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.75C5.41421 17.75 5.75 17.4142 5.75 17C5.75 16.5858 5.41421 16.25 5 16.25V17.75ZM3 17H2.25C2.25 17.4142 2.58579 17.75 3 17.75V17ZM3 11L2.30364 10.7215C2.26821 10.81 2.25 10.9046 2.25 11H3ZM5 6V5.25C4.69332 5.25 4.41754 5.43671 4.30364 5.72146L5 6ZM14 6L14.5857 5.53148C14.4433 5.35357 14.2278 5.25 14 5.25V6ZM18 11L17.4143 11.4685C17.5567 11.6464 17.7722 11.75 18 11.75V11ZM21 17V17.75C21.4142 17.75 21.75 17.4142 21.75 17H21ZM19 16.25C18.5858 16.25 18.25 16.5858 18.25 17C18.25 17.4142 18.5858 17.75 19 17.75V16.25ZM15 17.75C15.4142 17.75 15.75 17.4142 15.75 17C15.75 16.5858 15.4142 16.25 15 16.25V17.75ZM9 16.25C8.58579 16.25 8.25 16.5858 8.25 17C8.25 17.4142 8.58579 17.75 9 17.75V16.25ZM3 10.25C2.58579 10.25 2.25 10.5858 2.25 11C2.25 11.4142 2.58579 11.75 3 11.75V10.25ZM18 11.75C18.4142 11.75 18.75 11.4142 18.75 11C18.75 10.5858 18.4142 10.25 18 10.25V11.75ZM11.25 11C11.25 11.4142 11.5858 11.75 12 11.75C12.4142 11.75 12.75 11.4142 12.75 11H11.25ZM12.75 6C12.75 5.58579 12.4142 5.25 12 5.25C11.5858 5.25 11.25 5.58579 11.25 6H12.75ZM5 16.25H3V17.75H5V16.25ZM3.75 17V11H2.25V17H3.75ZM3.69636 11.2785L5.69636 6.27854L4.30364 5.72146L2.30364 10.7215L3.69636 11.2785ZM5 6.75H14V5.25H5V6.75ZM13.4143 6.46852L17.4143 11.4685L18.5857 10.5315L14.5857 5.53148L13.4143 6.46852ZM18 11.75H19V10.25H18V11.75ZM19 11.75C19.6904 11.75 20.25 12.3096 20.25 13H21.75C21.75 11.4812 20.5188 10.25 19 10.25V11.75ZM20.25 13V17H21.75V13H20.25ZM21 16.25H19V17.75H21V16.25ZM15 16.25H9V17.75H15V16.25ZM3 11.75H18V10.25H3V11.75ZM12.75 11V6H11.25V11H12.75Z",
    fill: "#282C87",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.0c602739138529cb0aa01b1f5962caa6.svg";
export { ForwardRef as ReactComponent };